/**
 * 客戶對公司統包（company_fixed）服務款直付公司，不經平台代收；
 * 平台服務款不計抽成（收入主要為 Premium 訂閱等）。
 */
export function skipsPlatformServiceCommission(
  isCompanyFixed: boolean | undefined
): boolean {
  return isCompanyFixed === true;
}

export type ZeroServiceCommissionSnapshot = {
  serviceFee: number;
  baseAmount: number;
  commission: number;
  matchingFee: number;
  platformFee: number;
  craftsmanEarnings: number;
  totalCustomerCharge: number;
  commissionRate: number;
  isPremium: boolean;
  isEmergency: boolean;
};

export function buildZeroPlatformServiceCommission(args: {
  serviceFee: number;
  baseAmount: number;
  isPremium?: boolean;
  isEmergency?: boolean;
  videoConsultationFee?: number;
  warrantyFee?: number;
}): ZeroServiceCommissionSnapshot {
  const videoConsultationFee = args.videoConsultationFee ?? 0;
  const warrantyFee = args.warrantyFee ?? 0;
  const baseAmount = Math.round(args.baseAmount * 100) / 100;
  const serviceFee = Math.round(args.serviceFee * 100) / 100;

  return {
    serviceFee,
    baseAmount,
    commission: 0,
    matchingFee: 0,
    platformFee: 0,
    craftsmanEarnings: baseAmount,
    totalCustomerCharge:
      Math.round((baseAmount + videoConsultationFee + warrantyFee) * 100) / 100,
    commissionRate: 0,
    isPremium: args.isPremium ?? false,
    isEmergency: args.isEmergency ?? false,
  };
}
